<script>
import ModalWrapperChoice from "@/components/modals/ModalWrapperChoice";

export default {
  name: "UpgradeMechanicLockModal",
  components: {
    ModalWrapperChoice
  },
  props: {
    upgrade: {
      type: Object,
      required: true
    },
    isImaginary: {
      type: Boolean,
      required: true,
    },
    specialLockText: {
      type: String,
      required: false,
      default: null,
    }
  },
  computed: {
    upgradeStr() {
      return this.isImaginary ? "Мнимое Улучшение" : "Улучшение Реальности";
    },
    lockEvent() {
      return this.specialLockText ?? this.upgrade.lockEvent;
    }
  },
  methods: {
    disableLock() {
      this.upgrade.setMechanicLock(false);
    }
  }
};
</script>

<template>
  <ModalWrapperChoice
    @confirm="disableLock"
  >
    <template #header>
      {{ upgradeStr }} Фиксатор Условий
    </template>
    <div class="c-modal-message__text">
      Вы уверены, что хотите {{ lockEvent }}? Делая это сейчас вы
      <span class="l-emphasis">
        нарушите требование для
        {{ upgradeStr == "Мнимое Улучшение" ? "Мнимого Улучшения" : "Улучшения Реальности"}} "{{ upgrade.name }}"
      </span>
      <span :ach-tooltip="upgrade.requirement">
        <i class="fas fa-question-circle" />
      </span>
      <br>
      <br>
      Выбрав "Отмена", вы закроете это меню без последствий, выбрав "Отключить Фиксатор" вы отключите
      проверку требований для этого улучшения и предотвратите это сообщение от повторного появления,
      до тех пор пока не включите Фиксатор вновь.
      <br>
      <br>
      Ни одно из этих действий не совершит то действие, которое вы попытались осуществить, поэтому вам необходимо будет
      попытаться ещё раз.
    </div>
    <template #confirm-text>
      Отключить Фиксатор
    </template>
  </ModalWrapperChoice>
</template>

<style scoped>
.l-emphasis {
  font-weight: bold;
  color: var(--color-bad);
}
</style>
